<template>
  <div class="car-recommend2" v-show="cars.length > 0">
    <div class="car-recommend2__container">
      <!-- 标题栏 -->
      <div class="car-recommend2__title">
        <div class="car-recommend2__heading">Top Cars</div>
        <a :href="allCarsLink" class="car-recommend2__view">
          <div class="car-recommend2__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-recommend2__icon" alt="">
        </a>
      </div>

      <!-- 加载状态 - 临时隐藏 -->
      <!-- <div v-if="loading" class="car-recommend2__loading">
        <div class="car-recommend2__loading-text">Loading...</div>
      </div> -->

      <!-- 卡片容器 - PC版使用flex-wrap两行布局，移动版使用横向滚动 -->
      <div class="car-recommend2__cards"
        :class="{'car-recommend2__cards--mobile': deviceType === 'mobile'}">

        <!-- 单个卡片 -->
        <a v-for="(car, index) in cars" :key="`car-${index}`" class="car-recommend2__card"
          :href="getDetailLink(car)">

          <!-- 车辆图片 -->
          <img :src="car.image" class="car-recommend2__pic" alt="">

          <!-- 加速时间 -->
          <div class="car-recommend2__speed">
            <div class="car-recommend2__speed-value">
              <div class="car-recommend2__speed-number">{{ car.speedValue }}</div>
            </div>
            <div class="car-recommend2__speed-label">
              <div class="car-recommend2__speed-text">0–60-MPH Times</div>
            </div>
          </div>

          <!-- 基本信息区域 -->
          <div class="car-recommend2__baseinfo">
            <div class="car-recommend2__info">
              <!-- 车型和品牌 -->
              <div class="car-recommend2__card-title">
                <div class="car-recommend2__name">
                  <div class="car-recommend2__model">{{ car.model }}</div>
                  <div class="car-recommend2__brand">{{ car.brand }}</div>
                </div>
                <img :src="car.logo" class="car-recommend2__logo" alt="">
              </div>

              <!-- 信息分隔线 -->
              <div class="car-recommend2__divider"></div>

              <!-- 车辆类型信息 -->
              <div class="car-recommend2__type">
                <div class="car-recommend2__type-item">
                  <img src="@/assets/calendar.svg" class="car-recommend2__type-icon" alt="">
                  <div class="car-recommend2__type-text">{{ car.year }}</div>
                </div>
                <div class="car-recommend2__type-item">
                  <img src="@/assets/car-type.svg" class="car-recommend2__type-icon" alt="">
                  <div class="car-recommend2__type-text">{{ car.category }}</div>
                </div>
                <div class="car-recommend2__type-item">
                  <img src="@/assets/body-type.svg" class="car-recommend2__type-icon" alt="">
                  <div class="car-recommend2__type-text">{{ car.bodyType }}</div>
                </div>
              </div>

              <!-- 信息分隔线 -->
              <div class="car-recommend2__divider"></div>

              <!-- 价格信息 -->
              <div class="car-recommend2__price">
                <div class="car-recommend2__price-text">{{ car.price }}</div>
                <div class="car-recommend2__price-link">
                  <img src="@/assets/arrow_outward.svg" class="car-recommend2__arrow" alt="">
                </div>
              </div>
            </div>
          </div>

        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import navigationMixin from '@/mixin/navigationMixin.js';

export default {
  name: 'CarRecommend',
  mixins: [navigationMixin],
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      return this.getCarListUrl(this.$route.query);
    }
  },
  data () {
    return {
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchTopCars();
  },
  methods: {
    // 获取推荐车辆数据
    async fetchTopCars () {
      this.loading = true;
      this.error = null;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};

        // 调用global.js中的getRecommendedTopCars方法获取数据
        const res = await this.$global.server.getRecommendedTopCars(themeFilters);
        if (res.code === 200) {
          // 处理API返回的数据，并限制最多显示8条
          const apiData = res.data || [];
          const processedData = apiData.slice(0, 8).map(item => {
            // 从photos字段提取第一张图片作为封面
            const photos = item.photos ? item.photos.split(',') : [];
            const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

            // 返回处理后的数据，映射字段名称
            return {
              id: item.id,
              model: item.name, // API中是name字段，映射为model
              brand: item.brand,
              logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
              year: item.year || item.marketTime?.substring(0, 4) || '-',
              category: item.purpose || '-', // 使用purpose字段作为category
              bodyType: item.type || '-', // 使用type字段作为bodyType
              price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
              image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
              speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
            };
          });

          this.cars = processedData;
          console.log('[CarRecommend] Fetched top cars:', this.cars.length);
        } else {
          throw new Error(res.message || '获取推荐车辆失败');
        }
      } catch (error) {
        console.error('[CarRecommend] Error fetching top cars:', error);
        this.error = error.message || '获取推荐车辆失败';
      } finally {
        this.loading = false;
      }
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },
    getDetailLink (car) {
      return this.getCarDetailUrl(car);
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-recommend2 {
	display: flex;
	flex-direction: column;
	gap: rem(10);
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;
	padding: rem(50) rem(120);
	width: 100%;

	&__container {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #fff;
		font-size: rem(44);
		font-style: normal;
		font-weight: 900;
		line-height: rem(44); /* 100% */
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		cursor: pointer;
		border-radius: rem(100);
		background: #fff;
		display: flex;
		padding: rem(8) rem(14);
		align-items: center;
		gap: rem(6);
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		flex-shrink: 0;
		width: rem(14);
		height: rem(14);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-flow: row wrap;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		width: 100%;
		min-height: rem(300);
		position: relative;

		// 移动端横向滚动样式
		&--mobile {
			flex-wrap: nowrap;
			overflow-x: auto;
			scrollbar-width: none; // Firefox
			-ms-overflow-style: none; // IE and Edge

			&::-webkit-scrollbar {
				display: none; // Chrome, Safari, Opera
			}
		}
	}

	&__card {
		flex: 0 0 calc(25% - rem(12));
		max-width: calc(25% - rem(12));
		position: relative;
		// height: rem(350);
		border: 1px solid #e9e9e9;
		border-radius: rem(12);
		cursor: pointer;

		overflow: hidden;
	}

	&__baseinfo {
		background: rgba(255, 255, 255, 1);
		backdrop-filter: blur(10px);
		border-radius: 0 0 rem(12) rem(12);
		padding: rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		z-index: 2;
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__card-title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__name {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
	}

	&__model {
		color: #050b20;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	&__brand {
		color: #848998;
		text-align: left;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__logo {
		flex-shrink: 0;
		width: rem(36);
		height: rem(36);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: contain;
		position: relative;
	}

	&__divider {
		background: #050b20;
		opacity: 0.1;
		align-self: stretch;
		flex-shrink: 0;
		height: rem(1);
		position: relative;
	}

	&__type {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__type-item {
		display: flex;
		flex-direction: row;
		gap: rem(9);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	&__type-icon {
		flex-shrink: 0;
		width: rem(12);
		height: rem(12);
		position: relative;
	}

	&__type-text {
		color: #050b20;
		text-align: left;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__price {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__price-text {
		color: #050b20;
		text-align: left;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__price-link {
		border-radius: rem(50%);
		width: rem(16);
		height: rem(16);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	&__arrow {
		flex-shrink: 0;
		width: rem(16);
		height: rem(16);
		position: relative;
		overflow: visible;
	}

	&__pic {
		width: 100%;
		height: rem(185);
		object-fit: cover;
		z-index: 1;
	}

	&__speed {
		position: absolute;
		top: rem(6);
		left: rem(6);
		z-index: 2;
		display: flex;
		background: rgba(0, 0, 0, 0.5);
		border-radius: rem(8);
		overflow: hidden;
	}

	&__speed-value {
		background: rgba(0, 0, 0, 0.5);
		padding: rem(4) rem(8);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;
		text-align: center;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 700;
	}

	&__speed-label {
		padding: rem(4) rem(8);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;
		text-align: center;

		font-size: rem(10);
		line-height: rem(10);
		font-weight: 400;
	}

	&__loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__loading-text {
		font-size: rem(18);
		font-weight: 700;
		color: #405ff2;
	}

	&__error {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__error-text {
		font-size: rem(18);
		font-weight: 700;
		color: #ff0000;
	}

	&__empty {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__empty-text {
		font-size: rem(18);
		font-weight: 700;
		color: #848998;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-recommend2 {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-recommend2 {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__container {
			width: 100%;
		}

		&__cards {
			// 添加负边距抵消父容器的padding
			margin: 0 rem(-16);
			padding: 0 rem(16);
			width: calc(100% + rem(32));
		}

		&__heading {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}

		&__card {
			flex: 0 0 rem(280);
			max-width: rem(280);

			&:last-child {
				margin-right: 0;
			}
		}

		&__model {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__brand {
			font-size: rem(10);
			line-height: rem(10);
		}

		&__type-text {
			font-size: rem(10);
			line-height: rem(10);
		}

		&__price-text {
			font-size: rem(10);
			line-height: rem(10);
		}
	}
}
</style> 